export default __webpack_public_path__ + "static/media/Point 1 Icon.34315862.svg";